import KSelect from 'app/components/Modules/Form/KSelect'
import { RecordType } from 'app/constants/GlobalTypes'
import * as React from 'react'

const RentalSelect: React.FC<Partial<React.ComponentProps<typeof KSelect>>> = (props) => {
  return (
    <KSelect<any>
      allowClear
      required
      recordType={RecordType.rental}
      name="rental_id"
      optionLabelProp="rental_code"
      selectValueBy="id"
      optionRenderer={(item: IRental) => (
        <span>
          {item.rental_code} | {item.machine_names[0] || ''}
        </span>
      )}
      {...props}
    />
  )
}

export default RentalSelect
